import './InfoBox.css';

import { PureComponent } from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

export default class InfoBox extends PureComponent {
  static propTypes = {
    children: PropTypes.object.isRequired,
    colorClass: PropTypes.string,
    colorizeOnlyIcon: PropTypes.bool.isRequired,
    iconClass: PropTypes.string,
  };

  static defaultProps = {
    colorClass: 'bg-red',
    iconClass: 'fa fa-flag-o',
  };

  render() {
    const { colorizeOnlyIcon, colorClass, iconClass, children } = this.props;
    return (
      <div
        bg={colorClass}
        className={classNames(
          'info-box__wrapper',
          !colorizeOnlyIcon &&
            colorClass === 'aqua' &&
            'info-box__wrapper--aqua',
          !colorizeOnlyIcon &&
            colorClass === 'green' &&
            'info-box__wrapper--green',
          !colorizeOnlyIcon &&
            colorClass === 'maroon' &&
            'info-box__wrapper--maroon',
          colorizeOnlyIcon && 'info-box__wrapper--colorize',
        )}
      >
        <div className='info-box__icon'>
          <i className={iconClass} />
        </div>
        <div className='info-box__content'>{children}</div>
      </div>
    );
  }
}
